module.exports = __webpack_public_path__ + "3b2a943787792058c4f2af1fb354ce49.MP3";